import React from 'react';
export function Hero() {
  return <section id="about" className="relative overflow-hidden" style={{
    background: 'radial-gradient(120% 90% at 50% -10%, rgba(157,207,200,.5) 0%, rgba(157,207,200,.12) 44%, transparent 72%), linear-gradient(180deg, var(--tw-colors-paper-DEFAULT) 0%, var(--tw-colors-mist) 100%)'
  }} data-id="element-49">
      <div className="max-w-page mx-auto px-6 text-center py-[62px] md:py-[88px] pb-[70px] md:pb-[96px]" data-id="element-50">
        <span className="inline-flex items-center gap-[10px] mb-6" data-id="element-51">
          <span className="text-[0.72rem] font-semibold tracking-[0.18em] uppercase text-teal" data-id="element-52">
            About us
          </span>
        </span>

        <h1 className="font-display font-medium text-[clamp(2.3rem,5.2vw,3.65rem)] leading-[1.05] tracking-[-0.018em] mx-auto mb-6 max-w-[18ch] text-balance [font-optical-sizing:auto]" data-id="element-53">
          We make calm you can hold — and we{' '}
          <em className="italic text-teal" data-id="element-54">won't</em> oversell it.
        </h1>

        <p className="text-[clamp(1.05rem,1.7vw,1.22rem)] text-ink-60 max-w-[52ch] mx-auto" data-id="element-55">
          <strong className="text-ink font-semibold" data-id="element-56">
            Fermata Wellbeing builds quiet, low-tech tools for overloaded
            nervous systems.
          </strong>{' '}
          Our first is Chime — a slim steel pendant you breathe out through. No
          app, no streak, nothing to be bad at.
        </p>
      </div>
    </section>;
}